import { Modal } from "antd";
import "./feature-linking-dialog.scss";
import { useEffect, useState } from "react";

function FeatureLinkingDialog(props: {
  open: boolean;
  headerComponent?: React.ReactNode;
  lhsComponent?: React.ReactNode;
  rhsComponent?: React.ReactNode;
  variant?: "default" | "manage";
  title?: React.ReactNode;
  footerComponent?: React.ReactNode;
  onClose?: () => void;
}) {
  const {
    open,
    headerComponent,
    lhsComponent,
    rhsComponent,
    variant = "default",
    title,
    footerComponent,
    onClose
  } = props;
  const isManage = variant === "manage";

  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => setShowContent(true), 100);
      return () => clearTimeout(timer);
    }
    setShowContent(false);
    return () => {};
  }, [open]);

  return (
    <Modal
      title={isManage ? title : headerComponent}
      open={open}
      closable={isManage}
      onCancel={isManage ? onClose : undefined}
      mask={{ closable: false }}
      width={isManage ? 1000 : 1200}
      footer={isManage ? footerComponent : null}
      className={
        isManage
          ? "feature-activity-linking-dialog feature-linking-dialog--manage"
          : "feature-activity-linking-dialog"
      }
      destroyOnHidden
      centered
      data-testid="index-modal-featurelinkingdialog"
    >
      <div
        className={
          isManage ? "h-[480px] overflow-hidden" : "h-[550px] overflow-hidden"
        }
      >
        {showContent && (
          <div className="h-full flex items-stretch">
            <div
              className={
                isManage
                  ? "w-[40%] min-w-0 py-3 bg-ciq-neutral-50 h-full max-h-full overflow-hidden"
                  : "w-[30%] min-w-0 pb-3 bg-ciq-neutral-50 h-full max-h-full overflow-hidden"
              }
            >
              {lhsComponent}
            </div>
            <div
              className={
                isManage
                  ? "w-[60%] py-3 px-4 h-full max-h-full overflow-y-auto"
                  : "w-[70%] pb-3 px-4 h-full max-h-full overflow-y-auto"
              }
            >
              {rhsComponent}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default FeatureLinkingDialog;
